import Request from "./Request";

class ClientDataService {
    static async getClientDataForMonth({ clientId, epochMonth, getOnOrderData = false }: { clientId: string|number, epochMonth: number, getOnOrderData?: boolean }) {
        try {
            const params = {
                epochMonth: epochMonth,
                getOnOrderData: getOnOrderData ? 'true' : 'false',
            }
            const response = await Request.get(`/api/clients/${clientId}/month-data`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }

    static async getClientKpiData({ clientId, startEpochMonth, endEpochMonth, compareToYearsAgo }: { clientId: string|number, startEpochMonth: number, endEpochMonth: number, compareToYearsAgo: number }) {
        try {
            const params = {
                startEpochMonth: startEpochMonth,
                endEpochMonth: endEpochMonth,
                compareToYearsAgo: compareToYearsAgo,
            }
            const response = await Request.get(`/api/clients/${clientId}/kpi-data`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }

    static async getHealthCashFlowSummary({ clientId, endEpochMonth }: { clientId: string|number, endEpochMonth: number }) {
        try {
            const params = {
                endEpochMonth: endEpochMonth,
            }
            const response = await Request.get(`/api/clients/${clientId}/health-cash-flow-summary`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }

    static async getDataThroughDate({ clientId }: { clientId: string|number }) {
        try {
            const response = await Request.get(`/api/clients/${clientId}/data-through-date`);
            return response;
        } catch (error) {
            console.error(error);
        }
    }
}

export default ClientDataService;